import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription} from "../../../../../user/user-subscription";
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-percent-offer-banner',
    templateUrl: './percent-offer-banner.component.html',
    styleUrls: ['./percent-offer-banner.component.scss'],
    standalone: false
})
export class PercentOfferBannerComponent implements OnInit {
  protected readonly UserSubscription = UserSubscription;
  @Input() userSubscription: UserSubscription;
  @Output() onClaimOffer = new EventEmitter<string>();
  @Input() blkOffer: boolean = false;
  @Input() demoUser: boolean = false;
  @Input() oneWeekFreeExpired: boolean;
  @Input() oneWeekFreeNotExpired: boolean;
  @Input() paidNotExpired: boolean;
  @Input() hideButton: boolean;

  public title: string;

  constructor() { }

  ngOnInit() {
    this.getTitle();
  }

  public getTitle(): void {
    switch (true) {
      case (this.userSubscription && this.userSubscription.trialClient) || this.hideButton:
        this.title =  TextUtils.getText("text_blkOfferFreePlanTitle");
        break;
      case this.oneWeekFreeExpired:
        this.title =  TextUtils.getText("text_blkOffer1wfExpiredTitle");
        break;
      case this.paidNotExpired || this.oneWeekFreeNotExpired:
        this.title =  TextUtils.getText("text_blkOfferPaidTitle");
        break;
    }
  }

  public claimOffer(): void {
    this.onClaimOffer.emit();
  }

}
